// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2n0T4","title":"AfterBackImages_title__W2RU_","images":"AfterBackImages_images__3t9Ui"};